import { useMutation } from 'react-query';

// Axios Instance
import axiosInstance from 'services/API/API';

// Our Endpoints
import { sendEmailEndpoint } from 'shared/api-urls';

function useMutateSendEmail() {
	return useMutation(
		async ({
			templateName,
			emailSubject,
			emailRecepientList,
			emailCcList,
			emailVarArgs
		}) => {
			const emailPayload = {
				templateName,
				subject: emailSubject,
				to: emailRecepientList
			};

			const hasEmailCCList =
				Array.isArray(emailCcList) && emailCcList.length > 0;
			const hasEmailVarArgs = !!emailVarArgs;

			if (hasEmailCCList) {
				emailPayload.cc = emailCcList;
			}

			if (hasEmailVarArgs) {
				emailPayload.msgArgs = emailVarArgs;
			}

			const response = await axiosInstance.post(
				sendEmailEndpoint,
				emailPayload
			);

			return response.data;
		}
	);
}

export default useMutateSendEmail;
